import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { navLinks, contactInfo } from '../data/mock';
import { ArrowUpRight, Linkedin, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (link) => {
    if (link.isRoute) {
      navigate(link.href);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const element = document.querySelector(link.href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        const element = document.querySelector(link.href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <footer className="relative bg-black border-t border-white/[0.05]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Main Footer */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('#hero');
              }}
              className="text-3xl font-semibold tracking-tight text-white hover:text-accent transition-colors duration-300 inline-block mb-4"
            >
              <span style={{color: '#FF6B00'}}>W</span>ebysee<span className="text-accent">.</span>
            </a>
            <p className="text-white/50 max-w-md mb-6 leading-relaxed">
              Agence web premium spécialisée dans la création de sites internet sur-mesure. Du site vitrine au projet complexe, nous donnons vie à votre vision digitale.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/5 text-white/50 hover:bg-accent hover:text-black transition-all duration-300"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/5 text-white/50 hover:bg-accent hover:text-black transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/5 text-white/50 hover:bg-accent hover:text-black transition-all duration-300"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Navigation</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link);
                    }}
                    className="text-white/50 hover:text-accent transition-colors duration-300 flex items-center gap-2 group"
                  >
                    {link.label}
                    <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/ressources"
                  className="text-white/50 hover:text-accent transition-colors duration-300 flex items-center gap-2 group"
                >
                  Ressources
                  <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                  className="text-white/50 hover:text-accent transition-colors duration-300"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-white/50 hover:text-accent transition-colors duration-300"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="text-white/50">{contactInfo.address}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/[0.05] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Webysee. Tous droits réservés.
          </p>
                      <span className="hidden md:inline text-white/20">•</span>
            <p className="text-white/40 text-sm">
              Créé par{' '}
              <a
                href="https://webysee.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent hover:text-accent/80 transition-colors duration-300 font-medium"
              >
                webysee.com
              </a>
            </p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" className="text-white/40 hover:text-white text-sm transition-colors duration-300">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="text-white/40 hover:text-white text-sm transition-colors duration-300">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
